export default __webpack_public_path__ + "static/media/avr.bd7b6f53.svg";